// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdatePayPalSetting_cancelButton__2N6KS","formItem":"UpdatePayPalSetting_formItem__2U10C","buttonsContainer":"UpdatePayPalSetting_buttonsContainer__11Za6"};